<template lang="html">
  <ProductSelectionBase v-model="modelProxy" type="protection" v-bind="{entityLookup, filter, filters, showArchived, products, recommendedIds, previouslyUsedProducts}">
    <template #sidebar="{hasRecommendations}">
      <ProductFiltersProtection v-model="filters" v-bind="{hasRecommendations}" />
    </template>

    <template #tile="scope">
      <ProductTileProtection v-bind="scope" />
    </template>
  </ProductSelectionBase>
</template>

<script>
import {modelProxy} from '@helpers/vuex'

import ProductSelectionBase from './ProductSelectionBase'
import ProductFiltersProtection from './ProductFiltersProtection'
import ProductTileProtection from './ProductTileProtection'

export default {
  components: {
    ProductSelectionBase,
    ProductFiltersProtection,
    ProductTileProtection
  },
  props: {
    value: String, // productId
    filter: Function,
    showArchived: Boolean,
    entityLookup: {
      type: Object,
      required: true
    },
    products: {
      type: Object,
      required: true
    }, // {[productId]: product, ...more}
    previouslyUsedProducts: {
      type: Array,
      default: () => []
    },
    recommendedIds: {
      type: Array,
      default: () => []
    } // [productId, ...more]
  },
  data () {
    return {
      filters: {
        showRecommendations: true,
        onlyPreviouslyUsed: false,
        search: '',
        categories: []
      }
    }
  },
  computed: {
    modelProxy
  }
}
</script>

<style lang="scss" module>
</style>
